export const CHART_HEIGHTS = {
  dashboard: 320,
  details: 400,
} as const;
